import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Scene } from "@babylonjs/core/scene";
import { BuilderProvider } from "features/builder/context/BuilderContext";
import { AssetBar } from "./AssetBar";
import { BuilderScene } from "./scene";
import { RightPanel } from "./RightPanel";
import { BuilderHeader } from "./BuilderHeader";
import { LeftController } from "./LeftController";
import { PublishStepsPanel } from "./PublishStepsPanel";
import { EditHistoryButton } from "./EditHistoryButton";

export const Canvas = () => {
  const navigate = useNavigate();
  const [scene, setScene] = useState<Scene | null>(null);

  return (
    <BuilderProvider>
      <BuilderHeader />
      <LeftController />
      <RightPanel />
      <PublishStepsPanel onTest={() => navigate("preview")} />
      <EditHistoryButton />
      <AssetBar />
      <BuilderScene scene={scene} setScene={setScene} />
    </BuilderProvider>
  );
};
